<template>
    <section v-if="json" class="page-home" >
        <FeaturedSlides v-if="json.featurePanel"  mode="home" :bgContentArray="json.featurePanel"></FeaturedSlides>
        <WorkWithUs  :json="json"></WorkWithUs>
        <WorkWithUsQuotes :json="json"></WorkWithUsQuotes>
        <SocialBlock :isHome="true"></SocialBlock>
        <NewsSnippetBlock :isHomePage="true" :json="json.newsBlock"></NewsSnippetBlock>
        <VisionMission :json="json"></VisionMission>
    </section>
</template>
<script>
import axios from 'axios'
//import gsap, {} from 'gsap'
//import { SplitText} from 'gsap/SplitText'
import { mapState } from 'vuex'
import FeaturedSlides from "@/components/blocks/FeaturedSlides"
import WorkWithUs from "@/components/blocks/WorkWithUs"
import WorkWithUsQuotes from "@/components/blocks/WorkWithUsQuotes"
import SocialBlock from "@/components/blocks/SocialBlock"
import NewsSnippetBlock from "@/components/blocks/NewsSnippetBlock"
import VisionMission from "@/components/blocks/VisionMission"
import gh from "@/helpers/gh";
//gsap.registerPlugin(SplitText)
export default {
    name: "HomePage",
    components: {
        FeaturedSlides,
        WorkWithUs,
        WorkWithUsQuotes,
        SocialBlock,
        NewsSnippetBlock,
        VisionMission
    },
    data () {
        return {
            window: window,
            json: null,
            inPanelTransition: false,
            revealReady:false
        }
    },
    created () {

    },
    computed: {
        ...mapState({
            didInitialSiteTransition: state => state.didInitialSiteTransition
        }),
    },
    mounted () {
        const turl = gh.formatFeedUrl('home')
        axios.get((turl))
            .then((res) => {
                this.json = res.data
                if (this.didInitialSiteTransition) {
                    if (!this.inPanelTransition) {
                        setTimeout(this.reveal,10)
                    }
                }

            }).catch(() => {
        })
    },
    watch: {
        didInitialSiteTransition() {
            if (!this.inPanelTransition) {
                this.reveal()
            }

        }
    },
    methods: {
        reveal: async function() {
            this.inPanelTransition = true

            // await new SplitText('.page-home .txt', {
            //     type: 'words, chars',
            //     charsClass: 'txt-split'
            // });

            this.reveal2()
        },
        reveal2 () {

            // let tl = gsap.timeline({
            //     delay:(this.revealReady) ? 0 : 0.25
            // });

            // tl.fromTo('.page-home .txt .txt-split',
            //     {
            //         opacity: 0,
            //     },
            //     {
            //         duration: 0.35,
            //         opacity: 1,
            //         ease: Power3.easeOut,
            //         stagger: 0.007,
            //         onStart:this.revealReadyMethod
            //     },
            //     2
            // )
        },

        revealReadyMethod () {
            this.revealReady = true
        }
    }
}
</script>
<style lang="scss" scoped>
.test {
    margin: 80px 0;
    display: flex;
    justify-content: space-between;
    gap: 40px;
    align-items: stretch;
    img {
        height: 100%;
        width: auto;
        object-fit: contain;
    }
}
</style>
